import React from 'react';
import clsx from 'clsx';

import TimeLabel from '../../time-label/TimeLabel';
import ActionType from '../../action-type/ActionType';
import Attachments from '../attachments/Attachments';
import FieldValues from '../field-values/FieldValues';

import scss from './RequestCard.module.scss';

function RequestCard({ request, isSelected, onSelect, actionOptions }) {
  const { actionType, time, id, attachments, fieldValues } = request;

  const handleSelect = () => {
    onSelect(id);
  };

  return (
    <div
      className={clsx(scss.wrapper, isSelected && scss.selected)}
      role='button'
      onClick={handleSelect}
      onKeyDown={(e) => e.key === 'Enter' && handleSelect()}
      tabIndex={0}>
      {fieldValues ? <FieldValues fieldValues={fieldValues} /> : null}
      {attachments?.length ? <Attachments attachments={attachments} /> : null}
      <div className={scss.footer}>
        <ActionType selectedAction={actionType} actionOptions={actionOptions} isShowGroupLabel />
        <TimeLabel time={time} />
      </div>
    </div>
  );
}

export default RequestCard;
